import React from "react";
import Colegio from "../images/contenido/ColegioSanMartinDePorres7072.jpg";
import RoxanaBarrientos from "../images/contenido/RoxanaBarrientos.jpg";
import Mapa from "../images/contenido/mapa del perú colegios focalizados.jpg";
import Libro1 from "../images/contenido/67 Nuestro país 1.jpg";
import Libro2 from "../images/contenido/67 Nuestro país 2.jpg";
import Libro3 from "../images/contenido/67 Nuestro país 3.jpg";
import Spread from "../images/contenido/Spread libro.jpg";
import Guia from "../images/contenido/Cubierta final guia profesores.jpg";
import FotoLibros from "../images/contenido/FOTO LIBROS6.jpg";
import FotoNinos from "../images/contenido/Foto niños2.jpg";
import LibroMinedu1 from "../images/contenido/69 Nuestro país ministerio 1.jpg";
import LibroMinedu2 from "../images/contenido/69 Nuestro país ministerio 2.jpg";
import LibroMinedu3 from "../images/contenido/69 Nuestro país ministerio 3.jpg";
import LibroMinedu4 from "../images/contenido/69 Nuestro país ministerio 4.jpg";
import LibroMinedu5 from "../images/contenido/69 Nuestro país ministerio 5.jpg";
import LibroMinedu6 from "../images/contenido/69 Nuestro país ministerio 6.jpg";
import Recursos from "../images/contenido/recursos educativos en linea.jpg";
import VideoTutorial from "../images/contenido/VideosTutoriales.jpg";
import Laminas from "../images/contenido/Laminas.png";
import Ciudadania from "../images/contenido/laptop portal web ciudadania copia.jpg";
import ActividadesInteractivas from "../images/contenido/laptop actividades interactivas copia.jpg";
import Grabaciones from "../images/contenido/Z Traductoras_edited.jpg";
import Videos from "../images/contenido/ciudadania-pe-videos.jpg";
import Premio from "../images/contenido/Premio Iberoamericano_edited.jpg";
import Navigation from "../components/Navigation";
import { Helmet } from "react-helmet";

const ProyectoDemocracia = () => {
  return (
    <section className="nosotros ">
      <Helmet>
        <meta charSet="utf-8" />
        <title>
          Proyecto Democracia - Memoria 2014-2024 - Fundación Gustavo Mohme
          Llona
        </title>
        <meta
          property="og:title"
          content="Proyecto Democracia - Memoria 2014-2024 - Fundación Gustavo Mohme Llona"
        />
      </Helmet>
      <div id="gustavo-mohme-llona" className="bg-white">
        <div className="container d-flex header-page">
          <div className="column-0">
            <div className="pre-title">3.1</div>
            <h1 className="color-green title-small">
              Proyecto Democracia: construyendo ciudadanía desde la escuela
            </h1>
          </div>
          <div className="column-0">
            <div className="cont-mohme-0">
              <img
                src={Colegio}
                alt="Colegio San Martín de Porres 7072"
                className="mohme-0 border-img"
              />
              <div className="legend">
                Colegio San Martín de Porres 7072 (Villa El Salvador), una de
                las instituciones focalizadas como parte del proyecto.
              </div>
              <div className="block-green"></div>
            </div>
            <div className="block-green-light"></div>
          </div>
        </div>
        <div className="container">
          <div className="container-text">
            <p>
              Es el proyecto central del eje educación y ciudadanía de la
              fundación. Se materializa mediante el trabajo con maestros y
              estudiantes de escuelas públicas de diferentes regiones del Perú,
              para promover la formación ciudadana y los valores democráticos.
              Parte de la valoración de la diversidad como característica
              esencial de nuestro país y de la necesidad de avanzar hacia una
              mayor igualdad de derechos para todos los peruanos.
            </p>
            <h5>Objetivo principal</h5>
            <p>
              Aportar activamente a la formación de ciudadanos libres, activos,
              solidarios y responsables, capaces de contribuir decisivamente a
              sentar las bases de una sociedad más inclusiva, más democrática y
              menos desigual.
            </p>
            <h5>Objetivos específicos</h5>
            <ul>
              <li>
                Desplegar una estrategia de trabajo (principalmente en las
                escuelas) para el desarrollo de capacidades ciudadanas y
                democráticas.
              </li>
              <li>
                Proveer de recursos pedagógicos a estudiantes y maestros para el
                trabajo concreto en la escuela y las aulas.
              </li>
            </ul>

            <h5>El punto de partida</h5>
            <figure className="img-right img-m">
              <div className="block-green-light"></div>
              <img
                src={RoxanaBarrientos}
                alt="Firma de convenio"
                className="img-m"
              />
              <div className="legend">
                Firma de convenio con la entonces directora del Instituto de
                Estudios Peruanos, Roxana Barrantes.
              </div>
            </figure>
            <p>
              El inicio del proyecto fue la elaboración, en el 2015, de una
              investigación del Instituto de Estudios Peruanos (IEP) que
              permitió conocer las percepciones, necesidades y expectativas de
              los actores educativos sobre los temas vinculados a la ciudadanía.
              Con ello, se inició el desarrollo de los libros de la serie
              Nuestro país, destinados a los estudiantes de los primeros años de
              educación primaria.
            </p>

            <p>
              Desde ese momento, el proyecto ha sido diseñado y ejecutado en
              colaboración con el Instituto de Estudios Peruanos (IEP) y en
              alianza con instituciones como Fe y Alegría, el Jurado Nacional de
              Elecciones y el Ministerio de Educación.
            </p>

            <p>
              En su calidad de aliado institucional, el IEP contó con la
              posibilidad de presentar el proyecto al Fondo de Oportunidades de
              Centros Asociados al Think Tank Initiative, TTI por sus siglas en
              inglés. Dicho proyecto resultó favorecido y comenzó a
              implementarse durante el 2015 bajo su administración.
            </p>
            <div className="quote quote-center quote-green">
              <p>
                Un esfuerzo para promover activamente valores cívicos y
                democráticos en las escuelas de todo el Perú.
              </p>
            </div>
            <h4>3.1.1 SERIE NUESTRO PAÍS</h4>

            <p>
              Es la principal publicación del Proyecto Democracia y surge como
              una respuesta tangible y efectiva para llenar el vacío en cuanto a
              recursos para abordar los temas de ciudadanía en la educación de
              los niños peruanos.
            </p>
            <p>
              La serie está compuesta por textos escolares ilustrados para
              estudiantes de Educación Básica y guías de aula para profesores.
              Su autoría corresponde a Carolina de Belaunde, Mariana Eguren y
              Natalia González. Estos constituyen una herramienta fundamental
              para viabilizar y favorecer el trabajo de la ciudadanía en clase.
              Los libros han sido editados cuidando detalles que hacen más
              atractivo y funcional su uso: diseño gráfico, ilustraciones y
              lenguaje empleado.
            </p>
            <p>
              Promueven principalmente el desarrollo de competencias de
              convivencia, deliberación y participación. Han sido diseñados para
              fomentar el trabajo con las palabras, el vocabulario y, de esa
              manera, afianzar la lectoescritura. Sus contenidos se alinean con
              el currículo oficial del Ministerio de Educación del Perú.
            </p>
            <p>
              Nuestra propuesta educativa tiene como base un enfoque
              descentralista que valora la diversidad, fomenta la igualdad de
              derechos e incorpora temas y problemas de la realidad social
              peruana.
            </p>
            <div className="row-content bg-green">
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={Libro1}
                    alt="Nuestro país 1"
                    className="img-responsive"
                  />
                  <div className="legend">
                    Libro de primer grado. Primera edición (2017): 1 000
                    ejemplares (con el apoyo del JNE). Segunda edición (2018): 1
                    000 ejemplares (con el apoyo de Schroth Corporación
                    Papelera).
                  </div>
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={Libro2}
                    alt="Nuestro país 2"
                    className="img-responsive"
                  />
                  <div className="legend">
                    Libro de segundo grado. Primera edición (2017): 1 000
                    ejemplares (con el apoyo del JNE). Segunda edición (2018): 1
                    000 ejemplares (con el apoyo de Schroth Corporación
                    Papelera).
                  </div>
                </figure>
              </div>
            </div>
            <div className="card mb-1">
              <div className="quote-green">
                <p>
                  Ponemos al alcance de niños, maestros y directores materiales
                  pedagógicos pertinentes y de calidad.
                </p>
              </div>
              <div>
                <img src={Spread} alt="Libro" className="img-responsive" />
              </div>
            </div>
            <div className="row-content bg-green">
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={Libro3}
                    alt="Nuestro país 3"
                    className="img-responsive"
                  />
                  <div className="legend">
                    Libro de tercer grado. Primera edición (2017): 1 000
                    ejemplares. Segunda edición (2018): 1 000 ejemplares (con el
                    apoyo de Schroth Corporación Papelera).
                  </div>
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img src={Guia} alt="Guía" className="img-responsive" />
                  <div className="legend">
                    Para el libro de tercer grado de primaria se preparó,
                    además, una guía especial para los docentes.
                  </div>
                </figure>
              </div>
            </div>
            <h5>Distribución de los materiales</h5>
            <p className="mb-1">
              Los libros impresos fueron distribuidos en instituciones
              educativas aliadas con las que se establecieron convenios y se
              elaboraron planes educativos que incorporara la temática. En esta
              etapa inicial fue fundamental la colaboración lograda con Fe y
              Alegría, pues permitió ampliar el impacto del proyecto. La
              distribución de los materiales se realizó según la nómina de
              matriculados en las escuelas focalizadas desde el año 2017.
            </p>
            <figure className="">
              <img
                src={Mapa}
                alt="Mapa"
                className="img-responsive border-img"
              />
              <div className="legend">
                El proyecto llegó en su primera etapa a escuelas de las regiones
                de Ayacucho, Lambayeque, Lima y Piura.
              </div>
            </figure>
            <figure className="img-center">
              <div className="block-green"></div>
              <img src={FotoLibros} alt="Entrega de libros" className="" />
              <div className="legend">
                Fernando Torres y Macarena Moscoso, del equipo del IEP,
                trabajando con los libros en un colegio de Lambayeque.
              </div>
            </figure>
            <div className="card">
              <div className="quote-green">
                <p>
                  En esta primera etapa del proyecto se beneficiaron más de 2
                  400 estudiantes y más de 80 docentes.
                </p>
              </div>
              <div>
                <img src={FotoNinos} alt="Libro" className="img-responsive" />
              </div>
            </div>
            <div className="card-legend">
              <div className="legend">
                Estudiantes de segundo grado con los libros de la serie Nuestro
                país
              </div>
            </div>
            <h5>Capacitaciones en la escuela</h5>
            <p>
              Entre los años 2016 y 2019, la fundación y el equipo del Instituto
              de Estudios Peruanos ejecutaron diversos talleres y capacitaciones
              para afianzar el uso de los materiales de la colección Nuestro
              país. En estas actividades participaron docentes y directivos de
              las instituciones educativas focalizadas. Además, se realizaron
              visitas pedagógicas con la finalidad de brindar soporte pedagógico
              a los docentes y acompañar el uso del material pedagógico en el
              aula.
            </p>
            <p className="color-green">Colegios focalizados:</p>
            <ul className="color-green">
              <li>San Miguel de Piura (Piura, Piura)</li>
              <li>José Olaya Balandra (Veintiséis de Octubre, Piura)</li>
              <li>Víctor Francisco Rosales Ortega (Piura, Piura)</li>
              <li>María Montessori (Miraflores, Piura)</li>
              <li>1268 Gustavo Mohme Llona (Huaycán, Lima)</li>
              <li>7072 (San Martín de Porres, Lima)</li>
              <li>Fe y Alegría N.º 50 (San Juan Bautista, Ayacucho)</li>
              <li>Fe y Alegría N.º 28 (Nueve de Octubre, Lambayeque)</li>
            </ul>
            <figure className="img-center">
              <div className="block-green-light"></div>
              <img src={FotoLibros} alt="Entrega de libros" className="" />
              <div className="legend">
                Fernando Torres y Macarena Moscoso, del equipo del IEP,
                trabajando con los libros en un colegio de Lambayeque.
              </div>
            </figure>
            <figure className="img-center">
              <div className="block-green"></div>
              <img src={FotoLibros} alt="Entrega de libros" className="" />
              <div className="legend">
                Fernando Torres y Macarena Moscoso, del equipo del IEP,
                trabajando con los libros en un colegio de Lambayeque.
              </div>
            </figure>
            <h4>3.1.2 NUESTRO PAÍS: REEDICIÓN DEL MINISTERIO DE EDUCACIÓN</h4>
            <p>
              En el mes de julio del 2019, el Ministerio de Educación convocó a
              un conjunto de especialistas a una reunión de discusión sobre
              políticas educativas. En esta participó Natalia González (IEP),
              quien presentó los libros de la serie Nuestro país y comentó la
              posibilidad de aprovecharlos para el trabajo de los contenidos
              sobre ciudadanía en las diferentes áreas del currículo oficial.
              Tras esta reunión, el equipo fue invitado a mostrar los materiales
              a los especialistas del Viceministerio de Gestión Pedagógica y
              luego se organizó una reunión entre los especialistas del
              ministerio, la Fundación Mohme y el IEP. En esta, el ministerio
              solicitó formalmente la cesión de los contenidos para elaborar una
              nueva edición que sería parte de la dotación de libros
              distribuidos por el Estado desde el año 2020.
            </p>
            <p>
              La Fundación Mohme autorizó el inicio de este proceso y la
              Dirección de Educación Primaria del ministerio se encargó de la
              elaboración de cuadernos de trabajo para primero, segundo,
              tercero, cuarto, quinto y sexto grado de primaria. De esta manera,
              nuestra colección fue acogida por el Ministerio de Educación y la
              propuesta educativa de Nuestro país alcanzó una escala nacional.
            </p>
            <div className="row-content bg-green">
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={LibroMinedu1}
                    alt="Nuestro país 1"
                    className="img-responsive"
                  />
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={LibroMinedu2}
                    alt="Nuestro país 2"
                    className="img-responsive"
                  />
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={LibroMinedu3}
                    alt="Nuestro país 3"
                    className="img-responsive"
                  />
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={LibroMinedu4}
                    alt="Nuestro país 4"
                    className="img-responsive"
                  />
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={LibroMinedu5}
                    alt="Nuestro país 5"
                    className="img-responsive"
                  />
                </figure>
              </div>
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={LibroMinedu6}
                    alt="Nuestro país 6"
                    className="img-responsive"
                  />
                </figure>
              </div>
            </div>
            <div className="card-legend">
              <div className="legend">
                Los libros reeditados por el ministerio dieron alcance nacional
                a nuestra propuesta pedagógica con tirajes bastante elevados:
                primer grado (413 537 ejemplares), segundo grado (461 210
                ejemplares), tercer grado (487 703 ejemplares), cuarto grado
                (444 189 ejemplares), quinto grado (407 932 ejemplares), sexto
                grado (410 838 ejemplares).
              </div>
            </div>
            <div className="quote quote-center quote-green">
              <p>
                Más de dos millones y medio de manuales fueron impresos y
                distribuidos por el Ministerio de Educación del Perú.
              </p>
            </div>
            <h4>
              3.1.3 LÁMINAS <em>CIUDADANÍA ACTIVA</em>
            </h4>
            <p>
              Una colección de láminas sobre ciudadanía adaptadas del contenido
              de la serie Nuestro país y distribuidas con los tres diarios del
              Grupo La República para apoyar la iniciativa Aprendo en casa del
              Ministerio de Educación.
            </p>
            <p>
              Con ella, tras la suspensión de las clases presenciales, se puso
              al alcance de un amplio sector de la población un material impreso
              que buscaba complementar la educación a distancia y poner en
              agenda un tema central en el contexto de la crisis: el de la
              ciudadanía.
            </p>
            <p>
              Tras concretar una nueva alianza con el Ministerio de Educación,
              las láminas se entregaron con los diarios sin costo adicional.
              Además, el contenido fue subido a la web para la descarga gratuita
              desde los portales de aprendoencasa.pe, larepublica.pe y
              fundacionmohme.org
            </p>
            <p>
              La reedición del contenido supuso la incorporación de ejemplos
              contextualizados en la coyuntura actual y la priorización de temas
              relevantes para el país. Las actividades lúdicas se mantuvieron en
              un lugar destacado para incentivar su uso y favorecer aprendizajes
              significativos en casa. Las láminas fueron impresas en papel bond
              para que se pueda escribir sobre ellas y facilitar su uso. Este
              contenido fue empleado también por los especialistas de la
              estrategia Aprendo en casa como parte de los recursos ofrecidos en
              la programación semanal.
            </p>
            <div className="row-content">
              <div className="col videos-coyuntura">
                <figure className="">
                  <img
                    src={Laminas}
                    alt="Nuestro país 1"
                    className="img-responsive"
                  />
                  <div className="legend">
                    Los contenidos fueron adaptados para abordar problemáticas
                    vinculadas a la pandemia.
                  </div>
                </figure>
              </div>
              <div className="col">
                <ul className="color-green mt-1">
                  <li>
                    Tiraje promedio diario: 180 000 ejemplares por 29 días.
                  </li>
                  <li>Tiraje total: 5 220 000 láminas.</li>
                </ul>
                <div className="quote quote-center quote-green">
                  <p>
                    Las láminas fueron entregadas sin costo adicional con los
                    tres diarios impresos del Grupo La República en todo el
                    territorio nacional.
                  </p>
                </div>
              </div>
            </div>

            <div className="clear mb-1"></div>

            <h4>3.1.4 RECURSOS DIGITALES DE USO LIBRE</h4>
            <p>
              Los libros de Nuestro país y las láminas de Ciudadanía activa han
              sido colgados en la web de la fundación para su descarga gratuita.
              Además, parte del contenido de la serie ha sido adaptada a fichas
              de trabajo para facilitar su uso pedagógico. Este año se ha
              empezado a trabajar en planes de digitalización de contenido con
              miras a alcanzar a más actores de nuestro sistema educativo.
              Además, estos recursos en línea han sido acompañados de videos
              tutoriales producidos por los especialistas pedagógicos del IEP.
            </p>
            <figure className="img-center">
              <div className="block-green-light"></div>
              <img
                src={Recursos}
                alt="recursos educativos"
                className="border-img"
              />
              <div className="legend">
                Todos los recursos educativos producidos por la fundación se
                encuentran disponibles para descarga gratuita en la web.
              </div>
            </figure>
            <div className="clear mb-1"></div>
            <figure className="img-left img-m">
              <img src={VideoTutorial} alt="Videos" className="img-m" />
              <div className="legend">
                Los recursos digitales subidos a la web se han acompañado con
                videos tutoriales.
              </div>
            </figure>
            <ul className="color-green mt-1">
              <li>Libros descargados: 10 265</li>
              <li>Láminas descargadas: 15 788</li>
              <li>Fichas descargadas: 1 820</li>
            </ul>
            <div className="clear mb-1"></div>

            <h4>
              3.1.5 CIUDADANÍA.PE
              <br />
              <br />
              Un portal para democratizar el acceso en la educación ciudadana
            </h4>
            <p>
              Es un portal de educación ciudadana con videos, actividades
              lúdicas, fichas, libros y otras herramientas pedagógicas de uso
              libre y gratuito. El site funciona como un repositorio general en
              el que se encuentra disponible el conjunto de herramientas
              pedagógicas creadas por la Fundación.
            </p>
            <p>
              El contenido se alinea con el plan curricular nacional y ha sido
              trabajado con especialistas del Instituto de Estudios Peruanos
              (IEP). La propuesta educativa tiene como fundamento los principios
              del eje de Educación y Ciudadanía de la Fundación Mohme: el
              respeto a la diversidad, el cuidado del medio ambiente, la
              igualdad de oportunidades para todos, el compromiso con el país.
            </p>
            <p>
              <strong>Beneficiarios</strong>
            </p>
            <p>
              El portal está principalmente dirigido a profesores de personal
              social o cualquier maestro interesado, pero el beneficiario final
              son los niños y niñas. Sin embargo, es una página que también
              puede ser trabajada en casa con el acompañamiento de un familiar.
              Son contenidos que pueden ser aprovechados de muchas maneras.
            </p>
            <figure className="img-center">
              <img src={Ciudadania} alt="ciudadania.pe" className="" />
            </figure>
            <div className="quote quote-center quote-green">
              <p>
                La publicación de material educativo digital permite ampliar el
                alcance de nuestra propuesta de educación ciudadana pues amplía
                el espectro geográfico y reduce los costos de impresión,
                almacenamiento y distribución de los materiales.
              </p>
            </div>
            <p>
              <strong>Validación del material</strong>
            </p>
            <p>
              En el segundo semestre del 2023 , como parte del curso Didáctica
              de la identidad y la convivencia democrática de Facultad de
              Educación de la Pontificia Universidad Católica del Perú; se
              realizó un proyecto de Responsabilidad Social Universitaria para
              validar el contenido de la plataforma <a href="https://ciudadania.pe/" target="_blank" rel="noopener" className="color-green">ciudadania.pe</a>.
            </p>
            <p>
              Los estudiantes del curso, organizados en grupos y bajo la
              orientación del profesor Alonso Germán Velasco Tapia, trabajaron
              con docentes de cuatro instituciones educativas estatales de Lima
              para hacer un diagnóstico de la forma en que se trabajan las
              competencias ciudadanas en el aula y el uso de recursos
              pedagógicos como los ofrecidos por <a href="https://ciudadania.pe/" target="_blank" rel="noopener" className="color-green">ciudadania.pe</a>. Esta
              colaboración continua en el 2024.
            </p>

            <h5>Actividades interactivas</h5>
            <p>
              Entre los componentes del portal se encuentra la sección de
              Actividades interactivas, organizadas en módulos temáticos que
              pueden ser trabajados en la escuela o en casa. Se trata de
              recursos pedagógicos que, al presentarse como juegos y retos,
              permiten afianzar el aprendizaje y el desarrollo de las
              competencias de convivencia.Las actividades pueden realizarse en
              línea o ser descargadas para el trabajo off line en zonas de
              conexión limitada a internet.
            </p>
            <figure className="img-center">
              <img src={ActividadesInteractivas} alt="ciudadania.pe" />
            </figure>

            <p>
              <strong>Temas abordados en los módulos:</strong>
            </p>
            <ol>
              <li>Mi familia y yo</li>
              <li>Mi barrio y yo</li>
              <li>Mi escuela y yo</li>
              <li>Mi país en el mundo</li>
              <li>¿Qué nos identifica como peruanos?</li>
              <li>¿Qué símbolos nos representan como país?</li>
              <li>¿Tenemos derechos y también deberes?</li>
              <li>¿Por qué votamos?</li>
              <li>¿Quiénes gobiernan nuestro país?</li>
              <li>¿Qué hace el poder legislativo?</li>
              <li>¿Qué hace el poder judicial?</li>
              <li>¿Quiénes somos los peruanos?</li>
              <li>¿Dónde vivimos los peruanos?</li>
              <li>¿Qué hablamos los peruanos?</li>
            </ol>

            <h5>Videos educativos sobre ciudadanía</h5>
            <p>
              Una serie de videos animados que abordan temas centrales para la
              convivencia democrática. Se han elaborado con lenguaje sencillo
              para acercar los conceptos planteados al público infantil y se han
              editado tanto en castellano, como también en las lenguas
              originarias más habladas del país: quechua (chanka y collao),
              aimara, asháninka, awajún y shipibo.
            </p>
            <p>
              Los videos fueron publicados Youtube y embebidos en el portal
              ciudadanía.pe. Se compartieron en las redes sociales de la
              Fundación, así como en las redes de nuestro aliado de comunicación
              para este proyecto: Grupo La República (Facebook de La República
              Lima, norte, centro y sur; El Popular y Wapa; así como en
              Instagram y Twitter).
            </p>

            <p>
              <strong>El reto de las lenguas originarias</strong>
            </p>
            <div className="quote quote-green">
              La publicación de videos en distintos idiomas permite mayor
              inclusión intercultural.
            </div>
            <p>
              Publicar los videos en idiomas nativos ha sido un gran reto, no
              solo por lo que significa trabajar tantas traducciones en
              simultáneo y editar tantas versiones por cada video sino porque
              todo esto nos ha planteado aprendizajes. Todo el proceso de
              trabajar con traductoras, principalmente mujeres, ha significado
              un aprendizaje de primera mano sobre nuestra diversidad y la
              importancia de seguir acercándonos entre peruanos. Este ejercicio
              de traducción también nos puso frente a muchos cuestionamientos
              sobre nuestras creencias. Por ejemplo, la imposibilidad de
              traducir algunas palabras sobre el funcionamiento del Estado
              peruano nos revelaba que vivimos en un país cuyas instituciones
              han sido construidas, en muchos casos, desde una visión
              centralista y alejada de los grupos étnicos que conforman nuestra
              nación. En este proceso ha sido vital el trabajo del equipo de la
              fundación y el de las mujeres reunidas por parlay.pe para el
              proceso de traducción. Fue un trabajo muy comprometido y riguroso.
            </p>

            <p>
              Contamos además, afortunadamente, con el apoyo de la Embajada de
              Canadá en el Perú y de la tercera generación de descendientes de
              Gustavo Mohme Llona para poder concretar el proyecto.
            </p>

            <figure className="img-center">
              <div className="block-green"></div>
              <img src={Grabaciones} alt="Entrega de libros" className="" />
              <div className="legend">
                Grabación de locuciones con traductoras e intérpretes.
              </div>
            </figure>

            <figure className="img-center">
              <img
                src={Videos}
                alt="Entrega de libros"
                className="border-img"
              />
            </figure>

            <p>
              <strong>El equipo</strong>
            </p>
            <p>
              El trabajo de producción de los videos involucró a las siguientes
              personas:
            </p>
            <ul>
              <li>Locución castellano: Victoria Villacorta</li>
              <li>Traducción aimara: Brigida Huahualuque Mamani</li>
              <li>Revisión aimara: Dilma Velasquez</li>
              <li>Locución aimara: Norma Bertha Quispe Ortiz (Aymar Aruni)</li>
              <li>Traducción asháninka: Janeth Jane Gonzales Puyenty</li>
              <li>Revisión asháninka: Li Sánchez</li>
              <li>Validación asháninka: Najashi Marishöri</li>
              <li>Locución asháninka: Li Sánchez</li>
              <li>
                Traducción awajún: Fabiana Juep Cahuaza (Mamais), Jessica Yania
                Yamas
              </li>
              <li>Revisión awajún: Adolfo Juep Nampin</li>
              <li>Validación awajún: Manuel Juep Cahuaza</li>
              <li>Locución awajún: Nugkai Lirio</li>
              <li>
                Traducción quechua chanka: Fanny A. Ccoyllo Sulca, Nila Tovar
                Gonzales
              </li>
              <li>Revisión quechua chanka: Escuela Amawta</li>
              <li>Locución quechua chanka: Fanny A. Ccoyllo Sulca</li>
              <li>
                Traducción quechua collao: Raymunda Ccoyo Quispe, Helen Quiñoes
                Loaiza,Yesica Cáceres
              </li>
              <li>Revisión quechua collao: Hilda Cañari</li>
              <li>Locución quechua collao: Guipsy Alata Ramos</li>
              <li>Traducción shipibo: Ronin Same</li>
              <li>Revisión shipibo: Luz Maria Cauper Pinedo</li>
              <li>Locución shipibo: Jessica Noemi Tananta Sanchez</li>
              <li>Gestión de traducciones: Érika Lucía</li>
              <li>Ilustración: Augusto Patiño</li>
              <li>Animación: Renzo Bravo</li>
              <li>Gestora web: Melissa Chávez</li>
              <li>
                Guión, edición y coordinación general: Ricardo Guerrero
              </li>{" "}
            </ul>

            <p className="color-green">
              <strong>
                El aporte de la Embajada de Canadá en el Perú permitió cubrir el
                costo de las traducciones, revisiones y locuciones a las lenguas
                originarias, así como parte del trabajo de animación.
              </strong>
            </p>
            <div className="quote quote-center quote-green">
              <p>
                En todos los casos se trabajó con locutoras mujeres hablantes
                nativas de cada lengua originaria.
              </p>
            </div>

            <h4>
              3.1.6 V PREMIO IBEROAMERICANO DE EDUCACIÓN EN DERECHOS HUMANOS
            </h4>
            <p>
              Debido a su misión formativa, su propuesta de educación ciudadana
              y su trayectoria en la promoción del respeto a los Derechos
              Humanos; este 2024, la Fundación ha sido invitada a participar
              como jurado del V Premio Iberoamericano de Educación en Derechos
              Humanos Óscar Arnulfo Romero.
            </p>
            <p>
              El objeto de este premio, impulsado por la Organización de Estados
              Iberoamericanos (OEI), es reconocer el trabajo de organizaciones e
              instituciones que han actuado de forma ejemplar en la defensa y
              promoción de los derechos humanos a través de la educación. El
              nombre del Premio tiene como fin destacar la labor del Monseñor
              Romero en la defensa de los Derechos Humanos, especialmente entre
              aquellos colectivos más vulnerables, y para vincularlo a acciones
              reales de promoción y protección de los Derechos Humanos como hizo
              a lo largo de su vida Monseñor Romero.
            </p>
            <div className="quote quote-green">
              Para la Fundación esta es una forma efectiva de apuntalar y
              fortalecer la educación en derechos humanos en nuestra región.
            </div>
            <p>
              La convocatoria permite la postulación de instituciones educativas
              (escuelas o universidades), empresas, organizaciones de la
              sociedad civil, fundaciones y organismos públicos que promuevan la
              defensa de los derechos humanos. Desde su primera edición, el
              premio ha contado con proyectos ganadores de Bolivia, Brasil,
              Colombia, Chile, Perú, El Salvador, España, México, Guatemala y
              Puerto Rico y República Dominicana; y ha recibido, hasta la fecha,
              más de 1.500 candidaturas provenientes de todos los países del
              espacio iberoamericano. Tras la fase de postulaciones nacionales,
              el 22 de abril, se inicia la fase internacional del premio que,
              este año, concluirá con un evento en Río de Janeiro.
            </p>
            <p>
              Los premios contemplan estímulos económicos, becas de formación en
              distintas instituciones así como el reconocimiento de los
              ganadores como embajadores de la Red Iberoamericana de Educación
              en Derechos Humanos y para la Ciudadanía Democrática lo que les
              posibilitará ser invitados por la organización a presentar sus
              iniciativas en otros foros y programas. En Perú los aliados de la
              OEI para esta edición del premio son la Delegación de la Unión
              Europea en Perú, la Coordinadora Nacional de Derechos Humanos, el
              Instituto de Democracia y Derechos Humanos de la Pontificia
              Universidad Católica del Perú (IDEHPUCP), el Ministerio de
              Justicia y Derechos Humanos y la Fundación Gustavo Mohme Llona.
            </p>
            <figure className="img-center">
              <div className="block-green-light"></div>
              <img
                src={Premio}
                alt="Premio iberoamericano"
                className="border-img"
              />
              <div className="legend">
                Ceremonia de lanzamiento de la V edición del premio con los
                representantes de las instituciones aliadas.
              </div>
            </figure>
          </div>
          <br />
          <br />
          <div className="mt-1"></div>
          <Navigation
            prev="https://fundacionmohme.org/especiales/memoria-2024/#educacion"
            textPrev="3. Eje Educación y Ciudadanía"
            next="https://fundacionmohme.org/especiales/memoria-2024/debate-educacion"
            textNext="3.2 Debate sobre la educación como problema"
          />
        </div>
      </div>
    </section>
  );
};

export default ProyectoDemocracia;
